// src/components/StarRating.js
import React from "react";

const StarRating = ({ rating, setRating }) => {
  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          style={{
            fontSize: "1.5rem",
            cursor: "pointer",
            color: star <= rating ? "#f5b301" : "#ccc",
          }}
          onClick={() => setRating(star)}
          onMouseEnter={() => setRating(star)}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
